import { render, staticRenderFns } from "./AppChatBot.vue?vue&type=template&id=33dab4e7&scoped=true&"
import script from "./AppChatBot.vue?vue&type=script&lang=js&"
export * from "./AppChatBot.vue?vue&type=script&lang=js&"
import style0 from "./AppChatBot.vue?vue&type=style&index=0&id=33dab4e7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33dab4e7",
  null
  
)

export default component.exports